/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum HirerQuestionType {
  FreeText = 'FreeText',
  SingleSelect = 'SingleSelect',
}

export interface CreateCustomQuestionInput {
  languageId: string;
  question: CustomQuestion;
}

export interface CustomQuestion {
  text: string;
  questionType: HirerQuestionType;
  options: Option[];
}

export interface Option {
  text: string;
  order: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
